import React from 'react';
import { MusicIcon, XIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-muted px-5 py-20 sm:py-24" data-id="element-194" data-mp="30xq2z6fh06r3">
      <div className="mx-auto max-w-4xl" data-id="element-195" data-mp="2w5q0b680mzqt">
        <div className="text-center" data-id="element-196" data-mp="2w4nc5622vbel">
          <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.4rem]" data-id="element-197" data-mp="2r7oe4cfamkb4">
            <MusicIcon className="mr-2 inline-block h-[0.8em] w-[0.8em] -translate-y-0.5 text-emphasis" aria-hidden="true" data-id="element-198" data-mp="2m9d4a1p009sw" />
            Vous vous reconnaissez dans ces{' '}
            <span className="italic text-emphasis" data-id="element-199" data-mp="2d85kspr55div">situations&nbsp;?</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm text-foreground/55" data-id="element-200" data-mp="289uayf0uj30n">
            Si vous répondez «&nbsp;oui&nbsp;» à l&apos;une de ces questions,
            Musique Prête™ a été créé spécialement pour vous&nbsp;:
          </p>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-201" data-mp="3jl3jl15am7m8">
          {recognizeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-surface px-5 py-5 shadow-card-sm" data-id="element-202" data-mp="3nmp67e7mq09m">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-203" data-mp="39o7i3fdtalr6" />
              <span className="text-sm font-medium leading-snug text-foreground/75" data-id="element-204" data-mp="3entwvt9aga23">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-xl text-center font-display text-lg font-bold italic text-emphasis sm:text-xl" data-id="element-205" data-mp="b4qtptzdng2r">
          Vous méritez bien mieux que tout cela. Votre passion pour la musique
          mérite de l&apos;ordre et de la simplicité.
        </p>
      </div>
    </section>;
}